import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
//import FeedbackContent from "../../components/feedback";
import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";
import AddIcon from "@mui/icons-material/Add";
import ManageOrganizations from "../../components/manage-organizations";
import { appLogger } from "../../utils";
interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Organizations = () => {
  const navigate = useNavigate();

  const [value, setValue] = React.useState(0);
  const [addForm, setAddForm] = React.useState(false);

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const handleCreateOrg = () => {
    navigate("/edit-organization/create");
  };

  return (
    <div className="product-wrap">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="user tab">
          <Tab label="Organizations" {...a11yProps(0)} />
          <Link className="add-pro-link" onClick={handleCreateOrg}>
            <AddIcon />
            Create Organization
          </Link>
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ManageOrganizations />
      </TabPanel>
    </div>
  );
};

export default Organizations;
